// src/testing/TestBridge.tsx
import React from 'react';
import usePreQualification from 'src/hooks/usePreQualification';

// We’ll toggle this from Playwright (see test.beforeEach)
const isTestEnv = typeof window !== 'undefined' && window.__E2E__ === true;

export const TestBridge: React.FC = () => {
  const { state } = usePreQualification();
  console.log('🚀 ~ TestBridge ~ state:', state);

  React.useEffect(() => {
    if (!isTestEnv) return;
    window.__APP_TEST__ = {
      getPreQualificationState: () => JSON.parse(JSON.stringify(state)), // deep clone for safety
    };
  }, [state]);

  return null;
};
